import React from 'react';
import { Link } from 'react-router-dom';
import {  SM, MD  } from '@zendeskgarden/react-typography';
import { Grid, Row, Col } from '@zendeskgarden/react-grid';
import { map, get } from 'lodash';
import {ProductsSectionHeader, Columns} from 'routes/Products/Products.styles.js'
import {variables} from 'theme/variables';
const {
  custom_navy
} = variables;


const ProductSpecs = ({productDetails}) => {
  const {
    listing_data
  } = productDetails

  const attributes = map(get(listing_data, 'features') || get(listing_data, 'key_features'), (d,k) => {
    return {
      title: k, 
      value: d
    }
  })

  return (
    <div style={{minWidth: '100%', maxWidth: '100%'}}>
      <Grid>
        <Row>
          <Col>
            <ProductsSectionHeader tag="h2" style={{fontSize: '26px', marginBottom: '20px'}} paddingBottomMd scaled bold>Key Features</ProductsSectionHeader>
          </Col>
        </Row>

        <Row>
          <Col size="auto">
            <Columns>
              {
                map(attributes, (attribute, i) => {
                  return (
                    <Row key={i} style={{marginBottom: '20px'}}>
                      <Col alignCenter style={{alignItems: 'flex-start'}}>
                        <div style={{
                          display: 'inline-block',
                          borderRadius:'100px',
                          maxWidth: '10px',
                          maxHeight: '10px',
                          minWidth: '10px',
                          minHeight: '10px',
                          width: '10px',
                          height: '10px',
                          background: custom_navy,
                          marginRight: '10px',
                          marginTop: '8px'
                        }}></div>
                        <MD as="span" light> {attribute.value || '--'}</MD>
                      </Col>
                    </Row>
                  )
                })
              }
            </Columns>
          </Col>
        </Row>
      </Grid>
    </div>
  )
}


export default ProductSpecs;
